var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFlowerBlueSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 51,
    viewBox: "0 0 42 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ddd_2514_1283)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.8661 15.5769C36.8613 -5.19231 4.85984 -5.19231 16.855 15.5769C4.85984 -5.19231 -11.1625 22.5 12.871 22.5C-11.1192 22.5 4.85984 50.1923 16.855 29.4231C4.85984 50.1923 36.8613 50.1923 24.8661 29.4231C36.8613 50.1923 52.8836 22.5 28.8501 22.5C52.8836 22.5 36.8613 -5.19231 24.8661 15.5769Z",
    fill: "#6CC8E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.8661 15.5769L25.5156 15.952C28.4528 10.8664 31.5313 8.92816 34.0147 8.64169C36.4868 8.35654 38.5949 9.67951 39.7195 11.6253C40.844 13.5709 40.9364 16.0547 39.4518 18.0499C37.9599 20.055 34.7361 21.75 28.8501 21.75V22.5V23.25C34.7361 23.25 37.9599 24.945 39.4518 26.9501C40.9364 28.9453 40.844 31.4291 39.7195 33.3747C38.5949 35.3205 36.4868 36.6435 34.0147 36.3583C31.5313 36.0718 28.4528 34.1336 25.5156 29.048L24.8661 29.4231L24.2167 29.7982C27.154 34.884 27.2935 38.5164 26.2999 40.8074C25.311 43.0878 23.1106 44.25 20.8605 44.25C18.6105 44.25 16.4101 43.0878 15.4212 40.8074C14.4276 38.5164 14.5671 34.884 17.5044 29.7982L16.855 29.4231L16.2055 29.048C13.2681 34.134 10.1922 36.0719 7.71235 36.3583C5.24427 36.6434 3.1403 35.321 2.01818 33.3753C0.896072 31.4296 0.804766 28.9453 2.28779 26.9498C3.77785 24.9447 6.9963 23.25 12.871 23.25V22.5V21.75C6.98499 21.75 3.76117 20.055 2.26926 18.0499C0.784733 16.0547 0.877076 13.5709 2.00159 11.6253C3.12617 9.67951 5.23428 8.35654 7.70637 8.64169C10.1898 8.92816 13.2683 10.8664 16.2055 15.952L16.855 15.5769L17.5044 15.2018C14.5671 10.116 14.4276 6.48363 15.4212 4.19264C16.4101 1.91225 18.6105 0.75 20.8605 0.75C23.1106 0.75 25.311 1.91225 26.2999 4.19264C27.2935 6.48363 27.154 10.116 24.2167 15.2018L24.8661 15.5769Z",
    stroke: "#1C1616",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ddd_2514_1283",
    x: 0.406006,
    y: 0,
    width: 40.9091,
    height: 51,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2514_1283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_2514_1283",
    result: "effect2_dropShadow_2514_1283"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.109804 0 0 0 0 0.0862745 0 0 0 0 0.0862745 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_dropShadow_2514_1283",
    result: "effect3_dropShadow_2514_1283"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect3_dropShadow_2514_1283",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlowerBlueSm);
export default __webpack_public_path__ + "static/media/flower-blue-sm.2093a476.svg";
export { ForwardRef as ReactComponent };